/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Book Icon
 *
 * @file BookIcon.jsx
 * @author Mohamed yasar arabath M
 * @since 0.0.1
 */


import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function BookIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.476 10.024H22.992C21.772 10.024 20.632 10.672 19.996 11.7C19.36 10.672 18.224 10.024 17 10.024H6.516C6.228 10.024 5.992 10.26 5.992 10.548V28.5161C5.992 28.804 6.228 29.04 6.516 29.04H16.092C16.324 29.04 16.512 29.2281 16.512 29.4601C16.512 29.7481 16.748 29.984 17.036 29.984H23.044C23.332 29.984 23.568 29.7481 23.568 29.4601C23.568 29.2281 23.756 29.04 23.988 29.04H33.476C33.764 29.04 34 28.804 34 28.5161V10.548C34 10.26 33.764 10.024 33.476 10.024ZM22.996 11.068H32.956V24.992H22.996C22.064 24.992 21.188 25.356 20.524 26.012V13.544C20.524 12.18 21.632 11.072 22.996 11.072V11.068ZM7.048 11.068H17.008C18.372 11.068 19.48 12.176 19.48 13.54V26.0201C18.828 25.3721 17.94 24.992 17.008 24.992H7.048V11.068Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
